import { getPaintings } from './getPaintings'
import { Painting } from 'models/painting'
export const editPainting = async (
  oldVersion,
  painting,
  image,
  setPaintings,
  setEditing
) => {
  const formData = new FormData()
  formData.append('oldversion', JSON.stringify(oldVersion))
  formData.append('painting', JSON.stringify(painting))
  formData.append('file', image.data)
  const response = await fetch('api/update', {
    method: 'POST',
    body: formData,
  }).then(async response => {
    const paintings: Painting[] = await getPaintings()
    setPaintings(paintings)
    setEditing(false)
  })
}
